import PopupSection from 'components/popup/PopupSection'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { ReactNode } from 'react'

import { t } from 'i18next'
import { AccountDoc, UserSettingsDoc } from 'types/api/changes'
import { Model } from 'types/model'
import i18n from 'i18n'
import { UserMenuPopup } from '../styled'
import { Email, Support } from '@mui/icons-material'
import { sendEmailToUs } from 'utils/env'
import { isGroupcalApp } from 'utils/appType'
import { useChatbase } from 'components/providers/ChatbaseProvider'
import { EmailUs } from 'assets/icons'
import { MenuContactIcon } from 'assets/icons/menu'
interface AccountActionProps {
  open: boolean
  setOpen: (b: boolean) => void
  children: ReactNode
  userSettings?: Model<UserSettingsDoc>
  account?: Model<AccountDoc>
  setMenuOpen?: (b: boolean) => void
}

function Content(props: AccountActionProps) {
  const chatbase = useChatbase()
  function toggleChatbase(): void {
    chatbase.openChat()
    props.setOpen(false)
    props.setMenuOpen?.(false)
  }

  const sendEmail = () => {
    sendEmailToUs()
    props.setMenuOpen?.(false)
  }

  return (
    <PopupSection title={`${t('contactUs')}`} noBottomBorder>
      <PopupSectionRow
        icon={<EmailUs />}
        title={t('emailUs')}
        action={sendEmail}
        actionId="email-button"
        iconClass="icon-regular"
        maxWidthIcon={20}
        onlyTitle
        actionBg
        engulfEntireRow
      />
      {isGroupcalApp() && (
        <PopupSectionRow
          actionId="support-chat"
          onlyTitle
          icon={<MenuContactIcon />}
          title={t('supportChat')}
          iconClass="icon-regular"
          maxWidthIcon={20}
          action={toggleChatbase}
          actionBg
          engulfEntireRow
        />
      )}
    </PopupSection>
  )
}

export default function ContactUsPopup(props: AccountActionProps) {
  return (
    <UserMenuPopup
      open={props.open}
      setOpen={props.setOpen}
      placement={i18n.dir() === 'ltr' ? 'right' : 'left'}
      fallbackPlacements={
        i18n.dir() === 'ltr' ? ['right', 'left', 'top'] : ['left', 'top']
      }
      content={<Content {...props} />}
    >
      {props.children}
    </UserMenuPopup>
  )
}
